/**
 * TrackCard Component for LicenseThisTrackModal
 */

import { getResponsiveTrackThumbnail } from '../../../../utils/track';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Thumbnail from '../../../atoms/images/Thumbnail';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';

interface IOwnProps {
  className: string;
  licenseString: string;
  track: GQL.ITrackSearchResult;
}

export class TrackCard extends React.Component<IOwnProps> {
  render() {
    const {
      className,
      licenseString,
      track,
    } = this.props;

    const classes = new BEM(className);
    const thumbnail = getResponsiveTrackThumbnail(track);

    return (
      <div {...classes()}>
        <Thumbnail
          responsiveAssets={thumbnail}
          size="large"
          withShadow
          responsive
          {...classes('thumbnail') }
        />
        <div {...classes('content') }>
          <Heading is="h4" {...classes('title') }>{track.title}</Heading>
          <Heading is="h6" {...classes('artist') }>{track.artist!.name}</Heading>
          <Span variant="description" textColor="bw6" block>{licenseString}</Span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/LicenseThisTrackModal/TrackCard.tsx